import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { 
  Monitor, 
  LineChart, 
  BrainCircuit, 
  Flower2, 
  ArrowRight 
} from "lucide-react";
import "./Programs.css";

const Programs = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Initialize AOS with settings for "Zero to Full" impact
    AOS.init({ 
      duration: 1000,       // Slower, smoother animation (1 second)
      easing: 'ease-out-cubic', // Smooth deceleration
      once: true,           // Play only once
      offset: 120,          // Trigger when 120px inside viewport
    });
  }, []);

  const handleExplore = (category) => {
    navigate(`/courses?category=${category}`);
  };

  const courseCards = [
    {
      title: "IT & Software",
      description: "Turn ideas into reality. From AI to Cloud, gain the technical prowess to innovate and lead in the tech era.",
      icon: <Monitor size={36} strokeWidth={1.5} />,
      category: "it",
      color: "#4F46E5",
      bgColor: "#E0E7FF",
    },
    {
      title: "Finance & Accounting",
      description: "Empower yourself with financial literacy. Decode markets and taxation to make smarter, profitable decisions.",
      icon: <LineChart size={36} strokeWidth={1.5} />,
      category: "financial",
      color: "#059669",
      bgColor: "#D1FAE5",
    },
    {
      title: "Skill Development",
      description: "Unlock the leader within. Build unshakable confidence and communication skills that set you apart from the crowd.",
      icon: <BrainCircuit size={36} strokeWidth={1.5} />,
      category: "skill",
      color: "#D97706",
      bgColor: "#FEF3C7",
    },
    {
      title: "Beauty & Wellness",
      description: "Redefine elegance. A comprehensive journey into bridal artistry, hair styling, and modern skin aesthetics.",
      icon: <Flower2 size={36} strokeWidth={1.5} />,
      category: "beauty",
      color: "#E11D48",
      bgColor: "#FFE4E6",
    },
];

  return (
    <section className="program-section">
      <div className="program-container">
        {/* Header Animation */}
        <div className="header-wrapper" data-aos="fade-down">
        <h2 className="contact-title">Our Programs</h2>
          <p className="section-subtitle">Expert-led courses designed for your career growth</p>
        </div>

        {/* Grid */}
        <div className="programs-grid">
          {courseCards.map((card, index) => (
            <div
              className="program-card"
              key={index}
              // 'zoom-in-up' creates the Zero -> Full effect
              data-aos="zoom-in-up" 
              data-aos-delay={index * 150} // Staggered delay
              onClick={() => handleExplore(card.category)}
              style={{ '--hover-color': card.color }}
            >
              <div className="card-content">
                <div 
                  className="icon-box" 
                  style={{ color: card.color, backgroundColor: card.bgColor }}
                >
                  {card.icon}
                </div>
                
                <h3 className="card-title">{card.title}</h3>
                <p className="card-desc">{card.description}</p>
                
                <div className="card-footer">
                  <span className="explore-text">View Details</span>
                  <ArrowRight size={18} className="arrow-icon" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Programs;